import gql from 'graphql-tag';

export const validateCouponQuery = gql`
  query ValidateCouponQuery(
    $code: String!
    $dispensaryId: String!
    $isReapplying: Boolean
    $orderSubtotalInCents: Int!
    $products: [couponValidationProductInput]
  ) {
    validateCouponQuery(
      code: $code
      dispensaryId: $dispensaryId
      isReapplying: $isReapplying
      orderSubtotalInCents: $orderSubtotalInCents
      products: $products
    ) {
      coupon {
        _id
        applicableCategories {
          category
          subcategory
        }
        code
        dispensaryId
        expDate
        fixedDiscountInCents
        percentDiscount
        restrictions {
          minimumPurchase
          minimumPurchaseInCents
          noSpecials
        }
        usedBy
      }
      isValid
      message
    }
  }
`;
